var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 20.5 35 C 20.5 40 28.5 40 28.5 35 Z",
    fill: "#246e33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 24.5 10.5 C 23.2 10.5 22.2 11.4 22.2 12.6 C 22.2 13.3 22.5 13.9 23 14.3 C 19 15.2 16 19 16 23.5 C 16 26.5 15.5 29 13.8 31.5 C 12.6 33.3 13.8 35.5 16 35.5 L 33 35.5 C 35.2 35.5 36.4 33.3 35.2 31.5 C 33.5 29 33 26.5 33 23.5 C 33 19 30 15.2 26 14.3 C 26.5 13.9 26.8 13.3 26.8 12.6 C 26.8 11.4 25.8 10.5 24.5 10.5 Z M 24.5 12 C 24.8 12 25.1 12.3 25.1 12.6 C 25.1 12.9 24.8 13.2 24.5 13.2 C 24.2 13.2 23.9 12.9 23.9 12.6 C 23.9 12.3 24.2 12 24.5 12 Z",
    fill: "#246e33",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.d225da2cdf5e42c9e13ae6d8d477e6e3.svg";
export { ForwardRef as ReactComponent };